export default {
    init() {
        // JavaScript to be fired on all pages
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // Burger & Navigation
        $('.burger').on('click touch', () => {
            $('body').toggleClass('no-scroll');
            $('.burger').toggleClass('burger--clicked');
            $('.navigation').toggleClass('navigation--active');
            $('.window-border').toggleClass('window-border--hidden');
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js